import { Messages } from "../types";

export const kk: Messages = {
    /* Verbs and nouns shared by every screen ------------------------------ */
    "common.add": "Қосу",
    "common.assign": "Тағайындау",
    "common.back": "Артқа",
    "common.cancel": "Болдырмау",
    "common.clear": "Таңдауды алу",
    "common.confirm": "Растау",
    "common.continue": "Жалғастыру",
    "common.delete": "Жою",
    "common.menu": "Мәзір",
    "common.open": "Ашу",
    "common.refresh": "Жаңарту",
    "common.remove": "Шығару",
    "common.retry": "Қайталау",
    "common.save": "Сақтау",
    "common.search": "Іздеу",
    "common.signIn": "Кіру",
    "common.signOut": "Шығу",

    /* Navigation ---------------------------------------------------------- */
    "nav.group.clinic": "Клиника",
    "nav.doctors": "Дәрігерлер",
    "nav.caretakers": "Қамқоршылар",
    "nav.patients": "Пациенттер",
    "nav.role": "Ұйым әкімшісі",
    "sidebar.collapse": "Мәзірді жию",
    "sidebar.expand": "Мәзірді жаю",

    /* Language switcher --------------------------------------------------- */
    "language.label": "Тіл",

    /* Turned-away session ------------------------------------------------- */
    "access.denied.title": "Кіруге рұқсат жоқ",
    "access.denied.subtitle":
        "Бұл консоль ұйым әкімшілеріне арналған. Ұйым әкімшісінің тіркелгісімен кіріңіз.",

    /* Command palette ----------------------------------------------------- */
    "palette.placeholder": "Бөлімге өту…",
    "palette.aria": "Бөлімге өту",
    "palette.empty": "Сәйкестік табылмады",
    "palette.section.sections": "Бөлімдер",
    "palette.section.actions": "Әрекеттер",
    "palette.foot.move": "жылжу үшін",
    "palette.foot.open": "ашу үшін",

    /* Action bar ---------------------------------------------------------- */
    "crud.selected": "Таңдалды:",
    "crud.hint.default": "Ашу үшін жолды таңдаңыз",
    "crud.hint.assignPeople": "Тағайындалатын адамдарды белгілеңіз",
    "crud.hint.removePatients": "Тізімнен шығарылатын пациенттерді белгілеңіз",
    "crud.hint.removeCaretakers": "Тізімнен шығарылатын қамқоршыларды белгілеңіз",

    /* Table columns ------------------------------------------------------- */
    "person.column.firstName": "Аты",
    "person.column.lastName": "Тегі",
    "person.column.phone": "Телефон",
    "person.column.email": "Эл. пошта",

    /* Form labels --------------------------------------------------------- */
    "person.field.firstName": "Аты:",
    "person.field.lastName": "Тегі:",
    "person.field.phone": "Телефон нөмірі:",
    "person.field.email": "Эл. пошта:",
    "person.field.password": "Құпия сөз:",
    "person.field.gender": "Жынысы:",
    "person.field.birthday": "Туған күні:",
    "person.field.country": "Ел:",
    "person.field.address": "Мекенжай:",
    "person.field.address2": "Мекенжай, 2-жол:",
    "person.field.city": "Қала:",
    "person.field.state": "Облыс:",
    "person.field.postcode": "Пошта индексі:",
    "person.field.allowedDistance": "Рұқсат етілген қашықтық:",
    "person.field.checkAllowedDistance": "Қашықтықты тексеру:",
    "person.field.doctorFirstName": "Дәрігердің аты:",
    "person.field.doctorLastName": "Дәрігердің тегі:",
    "person.field.doctorPhone": "Дәрігердің телефоны:",
    "person.field.diagnosis": "Диагноз:",

    /* Field examples ------------------------------------------------------ */
    "person.placeholder.firstName": "Айдар",
    "person.placeholder.lastName": "Сәрсенов",
    "person.placeholder.phone": "1 (344) 333-3333",
    "person.placeholder.email": "john.doe@email.com",
    "person.placeholder.password": "құпия сөз",
    "person.placeholder.country": "Іздеу үшін жаза бастаңыз",
    "person.placeholder.address": "Абай даңғ., 27",
    "person.placeholder.address2": "Сол жақта",
    "person.placeholder.city": "Алматы",
    "person.placeholder.state": "Алматы обл.",
    "person.placeholder.postcode": "050000",
    "person.placeholder.doctorFirstName": "Мұхтар",
    "person.placeholder.doctorLastName": "Сантос",
    "person.placeholder.doctorPhone": "+1 456 565-3443",
    "person.placeholder.diagnosis": "Диагноз",

    /* Field validation ---------------------------------------------------- */
    "person.rule.firstName": "атын енгізіңіз",
    "person.rule.phone": "телефон нөмірін енгізіңіз",
    "person.rule.email": "жарамды эл. пошта енгізіңіз",
    "person.rule.code": "кодты енгізіңіз",

    /* Enumerated values --------------------------------------------------- */
    "person.gender.male": "Ер",
    "person.gender.female": "Әйел",
    "person.gender.other": "Басқа",

    "patient.hint.allowedDistance": "Дабыл қағылатын үйден қашықтық (метр).",

    /* Search fields ------------------------------------------------------- */
    "list.search.person": "Аты, телефоны немесе эл. поштасы бойынша іздеу",
    "list.search.people": "Адамдарды іздеу",
    "list.search.patients": "Пациенттерді іздеу",
    "list.search.caretakers": "Қамқоршыларды іздеу",

    /* Empty lists --------------------------------------------------------- */
    "empty.default.title": "Әзірге бос",
    "empty.default.hint": "Қосылған жазбалар осы тізімде көрінеді.",
    "empty.assign.title": "Тағайындайтын адам қалмады",
    "empty.assign.hint": "Қолжетімді адамдардың барлығы осы тізімде.",
    "empty.patients.title": "Пациенттер тағайындалмаған",
    "empty.patients.hint": "Пациенттерді тағайындасаңыз, олар осында көрінеді.",
    "empty.caretakers.title": "Қамқоршылар тағайындалмаған",
    "empty.caretakers.hint": "Қамқоршыларды тағайындасаңыз, олар осында көрінеді.",

    /* Record tabs --------------------------------------------------------- */
    "tabs.doctor": "Дәрігер",
    "tabs.caretaker": "Қамқоршы",
    "tabs.patients": "Пациенттер",
    "tabs.caretakers": "Қамқоршылар",

    /* Records ------------------------------------------------------------- */
    "doctor.new": "Жаңа дәрігер",
    "doctor.one": "Дәрігер",
    "caretaker.new": "Жаңа қамқоршы",
    "caretaker.one": "Қамқоршы",
    "patient.new": "Жаңа пациент",
    "patient.one": "Пациент",

    /* Assignment ---------------------------------------------------------- */
    "assign.eyebrow": "Тағайындау",
    "assign.people.title": "Адамдарды тағайындау",
    "assign.caretakers.title": "Қамқоршыларды тағайындау",
    "assign.patients.title": "Пациенттерді тағайындау",
    "assign.caretakers.forDoctor": "Осы дәрігерге әлі тағайындалмаған қамқоршылар.",
    "assign.patients.forDoctor": "Осы дәрігерге әлі тағайындалмаған пациенттер.",
    "assign.patients.forCaretaker": "Осы қамқоршыға әлі тағайындалмаған пациенттер.",
    "assign.selection.count": {
        one: "{count} адам",
        other: "{count} адам"
    },

    /* Confirmations ------------------------------------------------------- */
    "confirm.remove.title": "Клиникадан шығару керек пе?",
    "confirm.remove.doctor":
        "«{name}» дәрігерін клиникадан шығарасыз ба? Тіркелгі сақталады, бірақ бұл ұйымға қатысы жойылады.",
    "confirm.remove.caretaker":
        "«{name}» қамқоршысын клиникадан шығарасыз ба? Тіркелгі сақталады, бірақ бұл ұйымға қатысы жойылады.",
    "confirm.remove.patient":
        "«{name}» пациентін клиникадан шығарасыз ба? Тіркелгі сақталады, бірақ бұл ұйымға қатысы жойылады.",
    "confirm.delete.title": "Толық жою керек пе?",
    "confirm.delete.doctor":
        "«{name}» дәрігерін толықтай жоясыз ба? Бұл әрекетті қайтару мүмкін емес.",
    "confirm.delete.caretaker":
        "«{name}» қамқоршысын толықтай жоясыз ба? Бұл әрекетті қайтару мүмкін емес.",
    "confirm.delete.patient":
        "«{name}» пациентін толықтай жоясыз ба? Бұл әрекетті қайтару мүмкін емес.",

    /* Failures ------------------------------------------------------------ */
    "auth.failed.title": "Аутентификация сәтсіз",
    "auth.failed.body": "Сеанс жарамсыз, қайта кіріңіз.",
    "error.server": "Сервер қатесі",

    /* Account ------------------------------------------------------------- */
    "account.title": "Тіркелгі",
    "account.email": "Эл. пошта",
    "account.notAuthenticated": "Аутентификация жасалмаған",

    /* Adding a patient ---------------------------------------------------- */
    "addPatient.eyebrow": "Пациент қосу",
    "addPatient.pageTitle": "Пациент қосу",
    "addPatient.phone.title": "Телефон нөмірі",
    "addPatient.phone.hint":
        "Нөмір пациентке тиесілі екенін растау үшін біржолғы код жібереміз.",
    "addPatient.phone.label": "Телефон нөмірі",
    "addPatient.phone.help": "Ел кодын қосыңыз.",
    "addPatient.sendCode": "Код жіберу",
    "addPatient.cannotAdd.title": "Пациентті қосу мүмкін емес",
    "addPatient.exists.own": "Бұл пациент біздің клиникада бар.",
    "addPatient.exists.other": "Бұл пациент басқа клиникада бар.",
    "addPatient.code.title": "Белсендіру коды",
    "addPatient.code.hint":
        "Пациенттің қолданбасында көрсетілген сегіз таңбалы кодты енгізіңіз.",
    "addPatient.code.label": "Код",
    "addPatient.code.placeholder": "XXXX-XXXX",
    "addPatient.confirm.title": "Нөмірді растаңыз",
    "addPatient.confirm.hint":
        "SMS арқылы алты таңбалы код жібердік. Нөмір пациентке тиесілі екенін растау үшін оны енгізіңіз.",
    "addPatient.confirm.pageTitle": "Телефон нөмірін растау",
    "addPatient.otp.label": "Код",
    "addPatient.otp.help": "Алты сан.",
    "addPatient.otp.placeholder": "xxx-xxx",
    "addPatient.resend": "Қайта жіберу",
    "addPatient.resendPrompt": "Хабарлама келмеді ме? Қайта жіберу",
    "addPatient.resendSeconds": "{seconds} с",

    /* Reference screen ---------------------------------------------------- */
    "countries.eyebrow": "Анықтама",
    "countries.title": "Елдер",
    "countries.subtitle":
        "Қосалқы бет: телефон нөмірлерін пішімдеу үшін пайдаланылатын елдер тізімі."
};
